import { render, staticRenderFns } from "./PersistStatusCargaView.vue?vue&type=template&id=2573a69f&"
import script from "./PersistStatusCargaView.vue?vue&type=script&lang=ts&"
export * from "./PersistStatusCargaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports